// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l_K2yy2p {
  position: fixed;
  bottom: 3.75rem;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 10vw;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-around;
          justify-content: space-around;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  padding: 0.25rem 0;
  z-index: 1000;
  height: auto;
  min-height: 3.5rem;
  width: 70vw;
  margin: 0 auto;
  -webkit-transform: translateY(0);
          transform: translateY(0);
  opacity: 1;
  -webkit-transition: opacity 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
  transition: opacity 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
  pointer-events: auto;
}
@media (min-width: 1024px) {
  .l_K2yy2p {
    display: none;
  }
}
.P1YxS4wJ {
  -webkit-transform: translateY(calc(100% + 1.25rem));
          transform: translateY(calc(100% + 1.25rem));
  opacity: 0;
  pointer-events: none;
}
.aJx0XFuk {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 0.25rem;
  padding: 0.25rem 1rem;
  color: #666666;
  -webkit-transition: color 0.2s ease;
  transition: color 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  min-width: 3.75rem;
}
.aJx0XFuk:active {
  opacity: 0.7;
}
.TXOwtJWW {
  color: #1890ff;
}
.ZAgvTZqz {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
}
.kxTwzDU1 {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}
.IrnpSsKN {
  font-size: 0.75rem;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/BottomNav.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,qCAAA;UAAA,6BAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,kBAAA;EAEA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gCAAA;UAAA,wBAAA;EACA,UAAA;EACA,gFAAA;EAAA,wEAAA;EAAA,gEAAA;EAAA,oGAAA;EACA,oBAAA;AAHF;ACCE;EAAA;IDKE,aAAA;EAFF;AACF;AAKA;EACE,mDAAA;UAAA,2CAAA;EACA,UAAA;EACA,oBAAA;AAHF;AAMA;ECmEE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EAjDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDvBA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,mCAAA;EAAA,2BAAA;ECuEA,mBAAA;EACA,kBAAA;EDtEA,kBAAA;AAKF;AAHE;EACE,YAAA;AAKJ;AADA;EACE,cAAA;AAGF;AAAA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,aAAA;EACA,cAAA;AAEF;AACA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;KAAA,mBAAA;AACF;AAEA;EACE,kBAAA;EACA,gBAAA;AAAF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.bottomNav {\n  position: fixed;\n  bottom: 3.75rem; // 60px\n  left: 0;\n  right: 0;\n  background: @white;\n  border: 1px solid @border-color; // border-width 保持 px\n  border-radius: 10vw;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: @spacing-xs 0;\n  // padding-bottom: calc(@spacing-xs + env(safe-area-inset-bottom, 0px)); // 考虑安全区域（iOS等）\n  z-index: @z-index-dropdown;\n  height: auto;\n  min-height: 3.5rem; // 56px 确保有足够的高度\n  width: 70vw;\n  margin: 0 auto;\n  transform: translateY(0);\n  opacity: 1;\n  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  pointer-events: auto;\n\n  .desktop({\n    display: none;\n  });\n}\n\n.bottomNavHidden {\n  transform: translateY(calc(100% + 1.25rem)); // 20px\n  opacity: 0;\n  pointer-events: none;\n}\n\n.navItem {\n  .button-reset();\n  .flex-center();\n  flex-direction: column;\n  gap: @spacing-xs;\n  padding: @spacing-xs @spacing-md;\n  color: @text-color-secondary;\n  transition: color 0.2s ease;\n  .touch-friendly();\n  min-width: 3.75rem; // 60px\n\n  &:active {\n    opacity: 0.7;\n  }\n}\n\n.navItemActive {\n  color: @primary-color;\n}\n\n.icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem; // 24px\n  height: 1.5rem; // 24px\n}\n\n.iconImg {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.label {\n  font-size: @font-size-xs;\n  font-weight: 500;\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bottomNav": `l_K2yy2p`,
	"bottomNavHidden": `P1YxS4wJ`,
	"navItem": `aJx0XFuk`,
	"navItemActive": `TXOwtJWW`,
	"icon": `ZAgvTZqz`,
	"iconImg": `kxTwzDU1`,
	"label": `IrnpSsKN`
};
export default ___CSS_LOADER_EXPORT___;
